module.exports = __webpack_public_path__ + "ce483fbe8b4942a04d092feeb9985381.svg";